import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import styled from 'styled-components';
import { Relative } from './Position';
import Avatar from './Avatar';
import theme from './theme';
var ChildAvatar = styled(Avatar).withConfig({
  displayName: "AvatarPair__ChildAvatar",
  componentId: "sc-1v5x8y5-0"
})(["position:absolute;right:-15%;bottom:-9%;box-shadow:0 0 0 2px rgba(255,255,255,0.8);"]);

var AvatarPair = function AvatarPair(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  var avatars = React.Children.map(children, function (child, i) {
    return i === 0 ? React.cloneElement(child, {
      size: 40
    }) : /*#__PURE__*/React.createElement(ChildAvatar, _extends({
      bg: "white"
    }, child.props, {
      size: 20
    }));
  });
  return /*#__PURE__*/React.createElement(Relative, _extends({
    display: "inline-flex"
  }, rest), avatars);
};

AvatarPair.displayName = "AvatarPair"; // styled() changes this

AvatarPair.displayName = 'AvatarPair';
AvatarPair.defaultProps = {
  theme: theme
};
export default AvatarPair;